import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReportTabLayout",
  props: {
    bodyClass: {
      type: String,
      default: ""
    }
  }
});